import sortBy from 'lodash.sortby';
import { useMemo } from 'react';
import { useAppSelector } from 'store/hooks';
import { BannerType } from 'types/banner.types';
import { Brand } from 'types/brand.types';
import { FeaturedShopType } from 'types/shop.types';

import { BrandsType } from '../../types/brand.types';
import { CMS_ITEM_NAME } from './cms-item-names';

export const useHomePageCmsData = () => {
  const activeBanner: BannerType = useAppSelector(({ cms }) => cms?.[CMS_ITEM_NAME.BANNER_MAIN]);
  const featuredShops: FeaturedShopType = useAppSelector(({ cms }) => cms?.[CMS_ITEM_NAME.FEATURED_SHOP]);
  const campaignsProducts = useAppSelector(({ cms }) => cms?.[CMS_ITEM_NAME.PRODUCT_CAMPAIGNS]);
  const featuredBrands = useAppSelector(({ cms }) => cms?.[CMS_ITEM_NAME.FEATURED_LINKS]);
  const productFilters = useAppSelector(({ cms }) => cms?.[CMS_ITEM_NAME.CATEGORIES]);

  const [brands, homepageBrands] = useAppSelector(({ cms }) => {
    const homepageBrands = cms?.[CMS_ITEM_NAME.BRANDS];
    const brands: Brand[] = sortBy(
      homepageBrands?.brands?.filter((brand) => brand.showOnHomepage),
      'homepageOrder',
    );

    return [brands, homepageBrands];
  });

  return useMemo(
    () => ({
      activeBanner,
      featuredShops,
      campaignsProducts,
      featuredBrands,
      homepageBrands: homepageBrands as BrandsType,
      brands: brands as Brand[],
      productFilters,
    }),
    [activeBanner, featuredShops, campaignsProducts, featuredBrands, brands, homepageBrands, productFilters],
  );
};
